class EivngCore{
	resetSettings(){
    localStorage.clear(); this.reloadWindow();
  }
  reloadWindow(){
    window.location.reload();
  }
}
export function getAuthHeaderVnrPwd(vnr, pwd){
  //  ("Authorization", "Basic " + btoa(username + ":" + password));
  const headers = new Headers();
  headers.append('Accept', 'application/json; charset=UTF-8');
  headers.append('Authorization', "Basic "+ btoa(vnr + ":" + pwd));
  headers.append( 'Content-type', 'application/json; charset=UTF-8')
  return headers
}

export function getHeaderWithBearerAutorization(jwt){
  const headers = new Headers();
  headers.append('Accept', 'application/json; charset=UTF-8');
  headers.append('Authorization', `Bearer ${jwt}`);
  headers.append( 'Content-type', 'application/json; charset=UTF-8');
  return headers
}

export let eivngCore = new EivngCore();

export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || "https://butler-test.laekh.de/backend/v1";

export const BACKEND_KAMMERDIENER_PREFIX = "";

export const MAX_ALLOWED_REF_PUNKTE = 12
